import { API_ADMIN } from 'src/lib/api'

export async function getHistorico(idEmpresa, data) {
  const response = await API_ADMIN.get(`/ConsoleProcessamento/Historico`, { idEmpresa, data })

  if (response.ok) {
    return response.data
  }

  throw response.originalError
}
